(function () {
  const root = document.getElementById("nuvra-my-designs");
  if (!root) return;

  const API_BASE = (root.dataset.apiBase || "").replace(/\/$/, "");
  const TOKEN_KEY = "nuvra_creator_token";
  const loginUrl = root.dataset.loginUrl || "/account/login";
  const registerUrl = root.dataset.registerUrl || "/account/register";
  const listUrl = root.dataset.listUrl || "/pages/list-design";
  const customerEmail = root.dataset.customerEmail || "";
  const customerId = root.dataset.customerId || "";

  if (!API_BASE) {
    root.innerHTML =
      '<div class="nuvra-seller-hub__error">My Designs is not configured yet. Set the API URL in theme settings.</div>';
    return;
  }

  function token() {
    return localStorage.getItem(TOKEN_KEY);
  }

  function setToken(value) {
    if (value) localStorage.setItem(TOKEN_KEY, value);
    else localStorage.removeItem(TOKEN_KEY);
  }

  async function api(path, options) {
    const headers = Object.assign({}, options && options.headers ? options.headers : {});
    const t = token();
    if (t) headers.Authorization = "Bearer " + t;
    const res = await fetch(API_BASE + path, Object.assign({}, options || {}, { headers: headers }));
    const data = await res.json().catch(function () {
      return {};
    });
    if (!res.ok) throw new Error(data.error || "Request failed");
    return data;
  }

  function esc(str) {
    const d = document.createElement("div");
    d.textContent = str == null ? "" : String(str);
    return d.innerHTML;
  }

  function statusLabel(status) {
    if (status === "draft") return "Draft";
    if (status === "pending") return "Pending Approval";
    if (status === "approved") return "Approved";
    if (status === "live") return "Live";
    if (status === "rejected") return "Rejected";
    return status;
  }

  function statusClass(status) {
    return "nuvra-design-status nuvra-design-status--" + esc(status);
  }

  function renderGate() {
    root.innerHTML =
      '<div class="nuvra-seller-hub__gate">' +
      '<h2 class="nuvra-display" style="font-size:1.4rem;margin:0 0 12px;">Sign in to see your designs</h2>' +
      "<p>Upload designs, publish to the store, and earn $2 shop credit per sale.</p>" +
      '<a href="' +
      esc(registerUrl) +
      "?return_url=" +
      encodeURIComponent(window.location.pathname) +
      '" class="nuvra-btn nuvra-btn--primary">Create Account</a> ' +
      '<a href="' +
      esc(loginUrl) +
      "?return_url=" +
      encodeURIComponent(window.location.pathname) +
      '" class="nuvra-btn nuvra-btn--ghost">Log In</a>' +
      "</div>";
  }

  function renderAuthLink() {
    root.innerHTML =
      '<div class="nuvra-seller-hub__card">' +
      "<p>Store account: <strong>" +
      esc(customerEmail) +
      "</strong></p>" +
      '<p style="color:#aaa;">Link your seller profile to manage designs.</p>' +
      '<div class="nuvra-seller-hub__field"><label>Password</label><input type="password" id="designs-password"></div>' +
      '<div id="designs-auth-error" class="nuvra-seller-hub__error" hidden></div>' +
      '<button type="button" class="nuvra-btn nuvra-btn--primary" id="btn-designs-login">Link Profile</button> ' +
      '<button type="button" class="nuvra-btn nuvra-btn--ghost" id="btn-designs-register">Create Seller Profile</button>' +
      "</div>";

    document.getElementById("btn-designs-login").addEventListener("click", async function () {
      const err = document.getElementById("designs-auth-error");
      err.hidden = true;
      try {
        const data = await api("/api/creator/login", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: customerEmail,
            password: document.getElementById("designs-password").value,
          }),
        });
        setToken(data.token);
        await boot();
      } catch (e) {
        err.textContent = e.message;
        err.hidden = false;
      }
    });

    document.getElementById("btn-designs-register").addEventListener("click", async function () {
      const err = document.getElementById("designs-auth-error");
      err.hidden = true;
      try {
        const data = await api("/api/creator/register", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: customerEmail,
            password: document.getElementById("designs-password").value,
            displayName: customerEmail.split("@")[0],
            shopifyCustomerId: customerId,
          }),
        });
        setToken(data.token);
        window.location.href = "/pages/build-my-shop";
      } catch (e) {
        err.textContent = e.message;
        err.hidden = false;
      }
    });
  }

  function renderDashboard(data) {
    const credit = data.shopCredit || data.earnings || {};
    const balance = credit.shopCreditBalance || 0;
    const sales = credit.totalSales || 0;
    const listings = data.listings || [];
    const handle = data.profile ? data.profile.handle : "";

    root.innerHTML =
      '<div class="nuvra-my-designs">' +
      '<div class="nuvra-my-designs__stats">' +
      '<div class="nuvra-seller-hub__card"><span class="nuvra-label">Store Credit</span><strong style="font-size:1.8rem;">$' +
      balance.toFixed(2) +
      "</strong><p>$2 per item sold</p></div>" +
      '<div class="nuvra-seller-hub__card"><span class="nuvra-label">Units Sold</span><strong style="font-size:1.8rem;">' +
      sales +
      "</strong></div>" +
      '<div class="nuvra-seller-hub__card"><span class="nuvra-label">Your Handle</span><strong>@' +
      esc(handle || "setup") +
      '</strong><a href="/pages/shop?handle=' +
      esc(handle) +
      '">Public shop</a></div>' +
      "</div>" +
      '<div class="nuvra-my-designs__actions">' +
      '<a href="' +
      esc(listUrl) +
      '" class="nuvra-btn nuvra-btn--primary">Upload New Design</a> ' +
      (balance >= 1
        ? '<button type="button" class="nuvra-btn nuvra-btn--ghost" id="btn-redeem-credit">Use Credit at Checkout</button>'
        : "") +
      "</div>" +
      '<h2 class="nuvra-display" style="font-size:1.2rem;margin:24px 0 12px;">Your Designs</h2>' +
      (listings.length
        ? '<div class="nuvra-my-designs__grid">' +
          listings
            .map(function (listing) {
              const canPublish = listing.status === "draft" || listing.status === "rejected";
              const mockup = listing.mockupUrl
                ? '<img src="' + esc(listing.mockupUrl) + '" alt="" class="nuvra-my-designs__thumb">'
                : '<div class="nuvra-my-designs__thumb nuvra-my-designs__thumb--empty">No mockup yet</div>';
              const liveLink =
                listing.status === "live" && listing.shopifyHandle
                  ? '<a href="/products/' +
                    esc(listing.shopifyHandle) +
                    '" class="nuvra-btn nuvra-btn--ghost">View Live</a>'
                  : "";
              const publishBtn = canPublish
                ? '<button type="button" class="nuvra-btn nuvra-btn--primary nuvra-publish-btn" data-id="' +
                  esc(listing.id) +
                  '">Publish to Store</button>'
                : "";
              return (
                '<article class="nuvra-my-designs__card">' +
                mockup +
                '<div class="nuvra-my-designs__body">' +
                "<h3>" +
                esc(listing.title) +
                "</h3>" +
                '<span class="' +
                statusClass(listing.status) +
                '">' +
                statusLabel(listing.status) +
                "</span>" +
                "<p>" +
                esc(listing.description || "").slice(0, 120) +
                "</p>" +
                '<div class="nuvra-my-designs__card-actions">' +
                publishBtn +
                liveLink +
                "</div></div></article>"
              );
            })
            .join("") +
          "</div>"
        : '<p class="nuvra-seller-hub__sub">No designs yet. <a href="' +
          esc(listUrl) +
          '">Upload your first design</a>.</p>') +
      '<div id="designs-action-msg" class="nuvra-seller-hub__sub" hidden></div>' +
      "</div>";

    root.querySelectorAll(".nuvra-publish-btn").forEach(function (btn) {
      btn.addEventListener("click", async function () {
        const id = btn.getAttribute("data-id");
        btn.disabled = true;
        const msg = document.getElementById("designs-action-msg");
        try {
          const result = await api("/api/seller/listings/" + id + "/publish", { method: "POST" });
          msg.textContent = result.message || "Submitted for approval!";
          msg.hidden = false;
          await boot();
        } catch (e) {
          msg.textContent = e.message;
          msg.hidden = false;
          btn.disabled = false;
        }
      });
    });

    const redeemBtn = document.getElementById("btn-redeem-credit");
    if (redeemBtn) {
      redeemBtn.addEventListener("click", async function () {
        try {
          const result = await api("/api/seller/credits/redeem", { method: "POST" });
          alert(result.message || "Discount code created.");
          await boot();
        } catch (e) {
          alert(e.message);
        }
      });
    }
  }

  async function boot() {
    if (!customerEmail) {
      renderGate();
      return;
    }
    if (!token()) {
      renderAuthLink();
      return;
    }
    try {
      const data = await api("/api/seller/dashboard");
      renderDashboard(data);
    } catch (e) {
      if (e.message && e.message.toLowerCase().includes("unauthorized")) {
        setToken(null);
        renderAuthLink();
        return;
      }
      root.innerHTML =
        '<div class="nuvra-seller-hub__error">' + esc(e.message) + "</div>";
    }
  }

  boot();
})();
